import { memo } from 'react';

interface AmountPresetsProps {
  value?: string;
  onClick?: (value: string) => void;
  amountPresets?: string[];
  disableAll?: boolean;
}

function _AmountPresets({
  onClick,
  value = '0',
  amountPresets = [],
  disableAll = false
}: AmountPresetsProps) {
  return (
    <div className="flex gap-2 w-full justify-between">
      {amountPresets.map((preset) => {
        return (
          <button
            title={`${preset}`}
            key={preset}
            onClick={() => onClick?.(preset)}
            className={`${
              value.toString() === preset.toString()
                ? 'text-wdap_amount_active bg-wdap_amount_bg_active'
                : 'border-wdap_amount_border text-wdap_amount bg-wdap_amount_bg'
            } border-none rounded-[10px] py-[6px] flex-1 text-[15px] font-medium `}
            disabled={disableAll}>
            {preset.endsWith('000') ? `${preset.slice(0, preset.length - 3)}k` : preset}
          </button>
        );
      })}
    </div>
  );
}

export const AmountPresets = memo(_AmountPresets);
